import { MaterialTheme } from "../.internal/themes/MaterialTheme";
export default MaterialTheme;